import { RouterView } from "vue-router";
import { CompanyTypeRouting } from "./company-type/company-type.routing";
import { CompanyRouting } from "./company/company.routing";

export const CooperationRouting = {
  path: "/cooperation",
  name: "basic-cooperation",
  redirect: "/cooperation/company-type/list",
  component: RouterView,
  meta: { title: "往来单位", icon: "danwei" },
  children: [...CompanyTypeRouting, ...CompanyRouting],
};
